// extracted by mini-css-extract-plugin
export default {"commentsCell":"CrmCellInternal_commentsCell__YvJdR","cellContainer":"CrmCellInternal_cellContainer__9JEL9","errorSpan":"CrmCellInternal_errorSpan__-6f3u"};